/* eslint-disable no-param-reassign */
import axios from 'axios'
// import Vue from 'vue'
const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      tahun: new Date().getFullYear(),
      refreshTimestamp: 0,
      stattistik: {
         izin: 0,
         nib: 0,
         ss: 0,
         syarat_belum: 0,
         menunggu_verifikasi: 0,
      },
      nibPerBulan: {
         data: [],
      },
      nibPerKecamatan: {
         data: [],
      },
      // New states for 7 components
      nibPerSkalaUsaha: {
         data: [],
      },
      nibPerStatus: {
         data: [],
      },
      nibPerJenis: {
         data: [],
      },
      topKbli: {
         data: [],
      },
      kbliPerSkala: {
         data: [],
      },
      kbliPerRisiko: {
         data: [],
      },
      kbliPerSektor: {
         data: [],
      },
   },
   actions: {
      triggerRefresh({ commit }) {
         commit('SET_REFRESH_TIMESTAMP', Date.now())
      },
      getStatistik({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         commit('SET_TAHUN', selectedYear)
         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/oss/statistik`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data && response.data.item
                  ? response.data.item
                  : response.data
               commit('SET_STATISTIK', data || {})

               rootState.isLoading = false
               return data
            },
            () => {
               rootState.isLoading = false
            },
         )
      },
      getNibPerBulan({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/oss/perbulan`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NIB_PER_BULAN', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getNibPerKecamatan({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/oss/perkecamatan`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NIB_PER_KECAMATAN', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      // New actions for 7 components
      getNibPerSkalaUsaha({ commit, rootState }, { year, tab }) {
         rootState.isLoading = true
         const tabValue = tab === 'tahun' ? 0 : 1
         return axios.get(`${baseURL}dashboard/oss/per-skala-usaha`, {
            params: { year, tab: tabValue },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NIB_PER_SKALA_USAHA', data)
               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getNibPerStatus({ commit, rootState }, { year, tab }) {
         rootState.isLoading = true
         const tabValue = tab === 'tahun' ? 0 : 1
         return axios.get(`${baseURL}dashboard/oss/per-status-penanaman-modal`, {
            params: { year, tab: tabValue },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NIB_PER_STATUS', data)
               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getNibPerJenis({ commit, rootState }, { year, tab }) {
         rootState.isLoading = true
         const tabValue = tab === 'tahun' ? 0 : 1
         return axios.get(`${baseURL}dashboard/oss/per-jenis-perusahaan`, {
            params: { year, tab: tabValue },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NIB_PER_JENIS', data)
               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getTopKbli({ commit, rootState }, year) {
         rootState.isLoading = true
         return axios
            .get(`${baseURL}dashboard/oss/kbli-top`, {
               params: { year },
            })
            .then(
               response => {
                  const data = response.data || {}
                  commit('SET_TOP_KBLI', data)
                  rootState.isLoading = false
                  return data
               },
               error => {
                  rootState.isLoading = false
                  return Promise.reject(error)
               },
            )
      },
      getKbliPerSkala({ commit, rootState }, year) {
         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/oss/kbli-per-skala-usaha`, {
            params: { year },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_KBLI_PER_SKALA', data)
               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getKbliPerRisiko({ commit, rootState }, year) {
         rootState.isLoading = true
         return axios
            .get(`${baseURL}dashboard/oss/kbli-per-tingkat-risiko`, {
               params: { year },
            })
            .then(
               response => {
                  const data = response.data || {}
                  commit('SET_KBLI_PER_RISIKO', data)
                  rootState.isLoading = false
                  return data
               },
               error => {
                  rootState.isLoading = false
                  return Promise.reject(error)
               },
            )
      },
      getKbliPerSektor({ commit, rootState }, year) {
         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/oss/kbli-per-sektor`, {
            params: { year },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_KBLI_PER_SEKTOR', data)
               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
   },
   mutations: {

      SET_TAHUN(state, tahun) {
         state.tahun = tahun
      },
      SET_REFRESH_TIMESTAMP(state, timestamp) {
         state.refreshTimestamp = timestamp
      },
      SET_STATISTIK(state, data) {
         state.stattistik = {
            ...state.stattistik,
            ...data,
         }
      },
      SET_NIB_PER_BULAN(state, data) {
         state.nibPerBulan = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_NIB_PER_KECAMATAN(state, data) {
         state.nibPerKecamatan = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      // New mutations for 7 components
      SET_NIB_PER_SKALA_USAHA(state, data) {
         state.nibPerSkalaUsaha = {
            data: data.data || {},
         }
      },
      SET_NIB_PER_STATUS(state, data) {
         state.nibPerStatus = {
            data: data.data || {},
         }
      },
      SET_NIB_PER_JENIS(state, data) {
         state.nibPerJenis = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_TOP_KBLI(state, data) {
         state.topKbli = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_KBLI_PER_SKALA(state, data) {
         state.kbliPerSkala = {
            data: data.data || {},
         }
      },
      SET_KBLI_PER_RISIKO(state, data) {
         state.kbliPerRisiko = {
            data: data.data || {},
         }
      },
      SET_KBLI_PER_SEKTOR(state, data) {
         state.kbliPerSektor = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },

   },
}
